import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import './MenuMobile.css';
import { MenuLink } from '../Menu.interface';

class MenuMobile extends Component<{ links: MenuLink[] }, {}> {
  state = {
    hamburgerDisplayed: false
  }

  toggleHamburger = () => {
    const hamburgerDisplayed = this.state.hamburgerDisplayed;
    this.setState({ hamburgerDisplayed: !hamburgerDisplayed });
  }

  render() {
    const hamburgerLabel = this.state.hamburgerDisplayed ? 'hamburger-menu hamburger-open' : 'hamburger-menu';
    const renderLinks = this.props.links.map(link => {
      return (
        <NavLink to={link.link} key={link.name}>
          <li className="hamburger-menu-link">{link.name}</li>
        </NavLink>
      )
    })

    return (
      <nav className="hamburger-menu-nav" >
        {this.state.hamburgerDisplayed
          ? <div className="page-cover" onClick={this.toggleHamburger}></div>
          : null
        }
        <label className={hamburgerLabel} onClick={this.toggleHamburger}>
          <span className="hamburger-menu-text">Navigace / menu</span>
          <span className="hamburger">
            <span className="icon-bar top-bar"></span>
            <span className="icon-bar middle-bar"></span>
            <span className="icon-bar bottom-bar"></span>
          </span>
          <ul>
            {renderLinks}
          </ul>
        </label>
      </nav>
    );
  };
}

export default MenuMobile;